<template>
  <el-time-picker
    v-model="vl"
    is-range
    range-separator="至"
    :start-placeholder="startPlaceholder"
    :end-placeholder="endPlaceholder"
    placeholder="选择时间范围"
    :value-format="format"
    :format="format"
    :disabled="disabled"
    :size="size"
    :clearable="clearable"
    @change="handleValue"
  />
</template>
<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Array
  },
  disabled: {
    type: Boolean
  },
  rangeSeparator: {
    type: String
  },
  startPlaceholder: {
    type: String,
    default: ''
  },
  endPlaceholder: {
    type: String,
    default: ''
  },
  size: {
    type: String
  },
  clearable: {
    type: Boolean,
    default: true
  },
  pickerOptions: {
    type: Object,
    default: () => {}
  },
  format: {
    type: String
  }
})

let vl = ref(['', ''])

// 监听外部值改变
watch(
  () => props.modelValue,
  (n) => {
    if (n && n[0] && n[1]) {
      vl.value = n
    } else {
      vl.value[0] = ''
      vl.value[1] = ''
    }
  },
  {
    deep: true,
    immediate: true
  }
)

const emits = defineEmits(['update:modelValue'])

// 选择完值
function handleValue() {
  if (vl.value && vl.value[0] && vl.value[1]) {
    emits('update:modelValue', [vl.value[0], vl.value[1]])
  } else {
    emits('update:modelValue', ['', ''])
  }
}
</script>
<style lang="scss"></style>
